import { render, staticRenderFns } from "./TemplateBasic.vue?vue&type=template&id=73bf6546&"
import script from "./TemplateBasic.vue?vue&type=script&lang=js&"
export * from "./TemplateBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports